import { createHOC } from 'vue-hoc';

import withUser from '~lib/common/hoc/withUser';
import withSubscriptionState from '~lib/common/hoc/withSubscriptionState';
import userManagement from '~lib/common/providers/userManagement';

import BillingPortalRedirect from './BillingPortalRedirect';

const options = {
  name: 'BillingPortalRedirectContainer',
  props: {
    user: {
      type: Object,
      default: null,
    },
    subscriptionState: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        error: null,
        billingPortalUrl: null,
      },
    };
  },
  methods: {
    async redirectToBillingPortal() {
      this.state.loading = true;
      this.state.error = null;
      if (!this.subscriptionState.stripeCustomerId) {
        return;
      }
      try {
        const createBillingPortalSessionResponse = await userManagement.post(
          '/payment/create-billing-portal-session'
        );
        if (!createBillingPortalSessionResponse.ok) {
          throw createBillingPortalSessionResponse.data ||
            new Error(createBillingPortalSessionResponse.error);
        }
        const sessionUrl = createBillingPortalSessionResponse.data.sessionUrl;
        window.location.href = sessionUrl;
      } catch (e) {
        console.error('Error when redirecting to billing portal', e);
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
  async created() {
    this.redirectToBillingPortal();
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
  },
};

const BillingPortalRedirectContainer = createHOC(
  BillingPortalRedirect,
  options,
  renderWith
);

export default withUser()(withSubscriptionState()(BillingPortalRedirectContainer));
